import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { ActiveInactiveFor, BusinessEnabledOption, BusinessWrapper, CloneBusinessOption, GeneralConfigType, InteractionType, KeyBoolean, KeyValues10, KeyValues15, KeyValues3, KeyValues5, KeyValues5Sets, KeyValueSet, LocalService, Paging, SelectedLocation, SellerInitialization, Status, StatusWithId, WorkingRangeType, Wrapper10Initialization, Wrapper15Initialization, Wrapper5Initialization, Wrappers10, Wrappers15, Wrappers5 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class SellerManagementService {
  private controllerName = service_controllers_methods.seller.controller;
  private methods = service_controllers_methods.seller.methods;
  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public onRefreshBusiness(businessId: string) {
    this.refreshBusinesses(businessId).subscribe(result => {
    });
  }

  public getSellerInitialization(strId: string, isTypesRequired: boolean = true, languageCode?: string): Observable<SellerInitialization> {
    let body = {
      sel: this.localService.getSelected(languageCode),
      dt: { isSelected: isTypesRequired, v1: strId, } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSellerInitialization, body);
  }

  public saveBusiness(wrapper: BusinessWrapper): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      wrapper: wrapper
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveBusiness, body);
  }

  public getBusinesses(isIncludeServiceProvider: boolean = false, isShowSpinner = true): Observable<KeyValues15[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: isIncludeServiceProvider ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBusinesses, body, isShowSpinner);
  }

  public getBusiness(strId: string, isAllInforRequired?: boolean, countryCode?: string, languageCode?: string): Observable<BusinessWrapper> {
    let body = {
      sel: this.localService.getSelected(languageCode, countryCode),
      strId: strId,
      isAllInforRequired: isAllInforRequired ? true : false
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBusiness, body);
  }

  public getBusinessName(strId: string, isAddress: boolean): Observable<KeyValueSet> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: strId, v1: isAddress ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBusinessName, body);
  }

  public getSearchInitialization(strBizId: string, selectedLocationLastUsed: SelectedLocation): Observable<Wrapper15Initialization> {
    let body = {
      sel: this.localService.getSelected(),
      pag: this.localService.getLastPagingSetup(GeneralConfigType.PagingSearch),
      selL: null,
      dt: strBizId,
      lastUsedSelL: selectedLocationLastUsed
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSearchInitialization, body);
  }

  public getSearchResults(paging: Paging, selectedLocation: KeyValues5, data: KeyValues3): Observable<Wrappers15> {
    if (paging == null)
      paging = this.localService.getLastPagingSetup(GeneralConfigType.PagingSearch);

    let body = {
      sel: this.localService.getSelected(),
      pag: paging,
      selL: selectedLocation,
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSearchResults, body, paging != null && !paging.isAutoRefresh);
  }

  public getSearchResultsLanguage(lstIds: any, paging: Paging): Observable<Wrappers15> {
    if (paging == null)
      paging = this.localService.getLastPagingSetup(GeneralConfigType.PagingSearch);

    let body = {
      sel: this.localService.getSelected(),
      lstIds: lstIds,
      pag: paging,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSearchResultsLanguage, body, paging != null && !paging.isAutoRefresh);
  }

  public getBusinessInitialization(): Observable<Wrapper10Initialization> {
    let body = {
      sel: this.localService.getSelected(),
      pag: this.localService.getLastPagingSetup(GeneralConfigType.PagingSellers),
      selD: this.localService.getLastPagingSetupAdditionalFilter(GeneralConfigType.PagingSellers)
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBusinessInitialization, body);
  }

  public getBusinessesAdmin(paging: Paging, isArchive: boolean, isBlockedOrInactive: boolean): Observable<Wrappers10> {
    if (paging == null)
      paging = this.localService.getLastPagingSetup(GeneralConfigType.PagingSellers);
    let body = {
      sel: this.localService.getSelected(),
      pag: paging,
      selD: this.localService.getLastPagingSetupAdditionalFilter(GeneralConfigType.PagingSellers),
      dt: { v1: isArchive ? '1' : '0', v2: isBlockedOrInactive ? '1' : '0' } as KeyValues3,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBusinessesAdmin, body, paging != null && !paging.isAutoRefresh);
  }
  public getAppointments(paging: Paging, strBusinessId, isIncludeExpired, strCustomerId, strProviderId): Observable<Wrappers15> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v2: strBusinessId, v3: isIncludeExpired ? '1' : '0', v4: strCustomerId, v5: strProviderId } as KeyValues5,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetAppointments, body, paging != null && !paging.isAutoRefresh);
  }

  public actionOnAppointment(strId, actionType): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: strId, v1: actionType } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ActionOnAppointment, body);
  }

  public getProductCategories(strId: string, isActive: boolean = true): Observable<KeyValues3[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strId, v2: isActive ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetProductCategories, body);
  }

  public addProductCategory(strBusinessId, languageContents): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      strId: strBusinessId,
      lan: languageContents
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.AddProductCategory, body);
  }

  public updateProductCategory(strId, languageContents): Observable<Status> {
    let body = {
      sel: this.localService.getSelected(),
      strId: strId,
      lan: languageContents
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdateProductCategory, body);
  }

  public getProductCategory(strId): Observable<KeyValues3[]> {
    let body = {
      sel: this.localService.getSelected(),
      strId: strId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetProductCategory, body);
  }

  public deleteProductCategory(strId): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.DeleteProductCategory, body);
  }

  public activeInactiveStatus(strId: string, actionFor: ActiveInactiveFor, countryCode: string = ''): Observable<StatusWithId> {
    let body = {
      strId: strId,
      sel: this.localService.getSelected(),
      iActionFor: parseInt(actionFor.toString()),
      dt: { v1: countryCode } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ActiveInactiveStatus, body);
  }

  public savePaymentDetail(data: KeyValues5): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: data,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SavePaymentDetail, body);
  }

  public getPaymentDetails(bizId: string, includeInactive: boolean, businessPaymentType: InteractionType): Observable<KeyValues10[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: bizId, v2: includeInactive ? '1' : '0', v3: businessPaymentType.toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPaymentDetails, body);
  }

  public saveWorkingHoursRange(data: KeyValues10, bizId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: data,
      dtC: { v1: bizId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveWorkingHoursRange, body);
  }

  public getWorkingRange(bizId: string, workingRangeType: WorkingRangeType): Observable<KeyValues10> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: bizId, v2: workingRangeType.toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetWorkingRange, body);
  }

  public getBusinesesBySearchKey(strSearchKey: string): Observable<KeyValues3[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strSearchKey } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBusinesesBySearchKey, body);
  }

  public getBusinessRelationShipRolesForUser(businessId: string, userId: string = ''): Observable<number[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: userId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBusinessRelationShipRolesForUser, body);
  }

  public isBusinessOptionEnabled(businessEnabledOption: BusinessEnabledOption, businessId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: businessEnabledOption.toString(), v1: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.IsBusinessOptionEnabled, body);
  }

  public getBusinessEnabledOptions(businessId: string = '', isSelectDefaultOption: boolean = false): Observable<KeyBoolean[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { isSelected: isSelectDefaultOption, v1: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBusinessEnabledOptions, body);
  }

  public saveBillingAdjustmentFormula(data: KeyValues5): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: data,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveBillingAdjustmentFormula, body);
  }

  public getBillingAdjustmentFormulas(businessId: string): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId } as KeyValues5,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBillingAdjustmentFormulas, body);
  }

  public refreshBusinesses(businessId: string): Observable<void> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId } as KeyValues3,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.RefreshBusinesses, body);
  }

  public savePrintIconDimensions(itemId: string, width: number, height: number): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: itemId, v2: width.toString(), v3: height.toString() } as KeyValues3,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SavePrintIconDimensions, body);
  }

  public getExpectedBusinessTypes(countryCode: string, businessId: string): Observable<string[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: countryCode, v2: businessId } as KeyValues3,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetExpectedBusinessTypes, body);
  }

  public getBusinessTaxCategories(countryCode: string, businessId: string): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: countryCode, v2: businessId } as KeyValues3,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBusinessTaxCategories, body);
  }

  public saveBusinessTaxCategory(countryCode: string, data: KeyValues5): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(countryCode),
      dt: data,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveBusinessTaxCategory, body);
  }

  public getBusinessTaxesFull(countryCode: string, businessId: string): Observable<KeyValues5Sets[]> {
    let body = {
      sel: this.localService.getSelected(countryCode),
      dt: { v1: businessId } as KeyValues3,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBusinessTaxesFull, body);
  }

  public getBusinessesByContactNumber(contactNumber: number): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: contactNumber ? contactNumber.toString().trim() : contactNumber.toString().trim() } as KeyValues3,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBusinessesByContactNumber, body);
  }

  public resetCurrentAcceptanceNumber(businessId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId } as KeyValues3,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ResetCurrentAcceptanceNumber, body);
  }

  public generateOtpForBusinessIdentificationCode(businessId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId } as KeyValues3,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GenerateOtpForBusinessIdentificationCode, body);
  }

  public getBusinessByBusinessIdentificationCode(businessVerificationCode: string, verificationPin: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessVerificationCode, v2: verificationPin } as KeyValues3,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBusinessByBusinessIdentificationCode, body);
  }

  public cloneBusiness(businessId: string, newBusinessName: string, newBusinessAddress: string, cloneOptions: CloneBusinessOption[]): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: newBusinessName, v3: newBusinessAddress } as KeyValues3,
      cloneOptions: cloneOptions
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.CloneBusiness, body, true, false, true);
  }
}
